import { get } from "@/vue/api/api";
import { oktaAxios as axios } from "@/vue/api/config";
import { EMAIL_BASE_URL, PRODUCT_UPDATES_ACCOUNT } from "@/vue/store/urls";

export const emailstatus = {
  state: {
    emails: [],
    templates: [],
  },
  getters: {
    getEmails: (state) => {
      return state.emails;
    },
    getEmailTemplates: (state) =>
      state.templates.filter(
        (template) =>
          template.versions?.length > 0 &&
          template.versions.some((version) => version.active)
      ),
  },
  mutations: {
    SET_EMAILS: (state, payload) => {
      state.emails = payload;
    },
    SET_TEMPLATES: (state, payload) => {
      state.templates = payload;
    },
  },
  actions: {
    fetchEmails: ({ commit }, payload) => {
      /**
       * Welcome traveler! If this SQL-like syntax query param scares you then good for you for sniffing out sql injections
       * however this is NOT actual sql. You can find the reference on how to use it here:
       * @link https://docs.sendgrid.com/for-developers/sending-email/getting-started-email-activity-api#keywords-and-operator-reference
       * Best of luck in your battles, lest you'll be soon replaced by our AI overlords
       * @type {string}
       */
      let query = `query=to_email='${payload.email}'`;
      if (payload.startDate && payload.endDate) {
        query += `AND last_event_time BETWEEN TIMESTAMP '${payload.startDate}' AND TIMESTAMP '${payload.endDate}'`;
      } else if (payload.startDate) {
        query += `AND last_event_time>=TIMESTAMP'${payload.startDate}'`;
      } else if (payload.endDate) {
        query += `AND last_event_time<=TIMESTAMP'${payload.endDate}'`;
      }

      get(`${EMAIL_BASE_URL}/messages?limit=1000&${query}`)
        .then((response) => {
          console.log("fetchEmails response");
          console.log(response);

          commit("SET_EMAILS", response.messages);
          payload.success("Emails retrieved");
        })
        .catch((error) => {
          console.log("fetchEmails error");
          console.log(error.message);
          payload.error(error.message);
        });
    },
    async fetchTemplates({ commit }) {
      const response = await axios.get(
        `${EMAIL_BASE_URL}/templates?account=${PRODUCT_UPDATES_ACCOUNT}`
      );
      commit("SET_TEMPLATES", response.data.templates);
      return response;
    },
  },
};
